import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";

import { MoveConflict, MoveConflictPolicy } from "./app/move";

function MoveConflictDialog({
  open,
  conflicts,
  onCancel,
  onChoose,
}: {
  open: boolean;
  conflicts: MoveConflict[];
  onCancel: () => void;
  onChoose: (policy: MoveConflictPolicy) => void;
}) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Move conflicts</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The destination already contains these names.
        </DialogContentText>
        <List>
          {conflicts.map(({ source, target }) => (
            <ListItem key={source.key} disableGutters>
              <ListItemText primary={source.key} secondary={target} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={() => onChoose("skip")}>Skip conflicts</Button>
        <Button
          color="error"
          variant="contained"
          onClick={() => onChoose("overwrite")}
        >
          Overwrite all
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoveConflictDialog;
